<template>
  <section class="section has-background-codeasy has-shadow" id="services">
    <div class="section-heading is-half">
      <h2 class="title is-2 has-text-white">Services</h2>
    </div>
    <div class="column is-10 is-offset-1">
      <div
        class="columns"
        style="margin-bottom: 3%"
        v-for="i in Math.ceil(services.length/2)"
        :key="i"
      >
        <div
          class="column services-container"
          v-for="service in services.slice((i-1)*2, i*2)"
          :key="service.title"
        >
          <div
            class="box is-full-height has-background-codeasy is-radiusless is-borderless is-paddingless"
          >
            <div class="content">
              <h3 class="title is-4 has-text-codeasy-primary" v-html="service.title"></h3>
              <h4
                class="has-text-white is-size-5 is-size-6-mobile has-text-weight-normal"
                v-html="service.content"
              ></h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column technologies-container">
      <div class="column is-10 is-offset-1 is-paddingless">
        <div class="columns">
          <div class="column">
            <h3
              class="is-size-3 is-size-4-mobile has-text-white is-uppercase"
              data-aos="flip-left"
              data-aos-duration="700"
            >Technologies</h3>
          </div>
        </div>
        <div class="columns is-mobile" v-for="i in Math.ceil(techLogos.length / 6)" :key="i">
          <div class="column" v-for="logo in techLogos.slice((i-1)*6, i*6)" :key="logo.alt">
            <div class="card logo has-background-transparent is-borderless">
              <div class="card-image">
                <figure class="image">
                  <picture>
                    <source :srcset="logo.newImageFormat" type="image/webp">
                    <img
                      :src="logo.traditionalImageFormat"
                      :alt="logo.alt"
                      data-aos="flip-up"
                      data-aos-delay="700"
                    >
                  </picture>
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <h3
              class="is-size-4 is-size-5-mobile has-text-codeasy-primary has-text-right"
              data-aos="flip-right"
              data-aos-delay="1000"
            >... and many more!</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ServicesPage',
  data () {
    return {
      services: [
        {
          title: 'Front End Development',
          content: `Creating beautifully and functionals user interfaces using the latest standards and technologies.
                We believe that every project has a soul, so we carefully select the framework to match them.`,
        },
        {
          title: 'Responsiveness',
          content: 'Mobile app? Web app? Desktop app? Any app? - Sure, we can do it! Nowdays app should be accessive on any device, OS or browser.',
        },
        {
          title: 'Back End Development',
          content: `Can't judge the book by the covers. The same thing is with the app. Good looking app without good backend is like a tree without roots.
                 Whether it's a web app, custom back-end system or an API, we create architectures that best suit your digital products and services.`,
        },
        {
          title: 'Project Management',
          content: `Project Management is the art of coordinating resources and directing uni-disciplinary groups
                so that the components of work performed by each group accumulates into a multi-disciplinary team effort which
                achieves the desired objectives (or contracted scope of work) on time and within budget."
                <br>
                <br>Well, we can help you achieve your objectives.`,
        },
      ],
      techLogos: [
        {
          traditionalImageFormat: require('@/assets/technology/vue.png'),
          newImageFormat: require('@/assets/technology/vue.webp'),
          alt: 'Vue',
        },
        {
          traditionalImageFormat: require('@/assets/technology/react.png'),
          newImageFormat: require('@/assets/technology/react.webp'),
          alt: 'React',
        },
        {
          traditionalImageFormat: require('@/assets/technology/angular.png'),
          newImageFormat: require('@/assets/technology/angular.webp'),
          alt: 'Angular',
        },
        {
          traditionalImageFormat: require('@/assets/technology/aws.png'),
          newImageFormat: require('@/assets/technology/aws.webp'),
          alt: 'Amazon Web Services',
        },
        {
          traditionalImageFormat: require('@/assets/technology/ts.png'),
          newImageFormat: require('@/assets/technology/ts.webp'),
          alt: 'TypeScript',
        },
        {
          traditionalImageFormat: require('@/assets/technology/csharp.png'),
          newImageFormat: require('@/assets/technology/csharp.webp'),
          alt: 'C#',
        },
        {
          traditionalImageFormat: require('@/assets/technology/dynamodb.png'),
          newImageFormat: require('@/assets/technology/dynamodb.webp'),
          alt: 'Amazon DynamoDB',
        },
        {
          traditionalImageFormat: require('@/assets/technology/mongodb.png'),
          newImageFormat: require('@/assets/technology/mongodb.webp'),
          alt: 'MongoDB',
        },
        {
          traditionalImageFormat: require('@/assets/technology/nodejs.png'),
          newImageFormat: require('@/assets/technology/nodejs.webp'),
          alt: 'Node.js',
        },
        {
          traditionalImageFormat: require('@/assets/technology/phonegap.png'),
          newImageFormat: require('@/assets/technology/phonegap.webp'),
          alt: 'PhoneGap',
        },
        {
          traditionalImageFormat: require('@/assets/technology/socketio.png'),
          newImageFormat: require('@/assets/technology/socketio.webp'),
          alt: 'Socket.IO',
        },
        {
          traditionalImageFormat: require('@/assets/technology/firebase.png'),
          newImageFormat: require('@/assets/technology/firebase.webp'),
          alt: 'Firebase',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~bulma";

$sizes: (0, 10, 15, 20, 25, 30, 50);
$positions: ("t", "l", "b", "r", "a");
$positionsX: (
  "t": "-top",
  "b": "-bottom",
  "l": "-left",
  "r": "-right",
  "a": ""
);

@each $size in $sizes {
  @each $position, $key in $positionsX {
    .v-m-#{$position}-#{$size} {
      margin#{$key}: $size + px;
    }
    .v-p-#{$position}-#{$size} {
      padding#{$key}: $size + px;
    }
  }
}

.section-heading {
  text-align: center;
  margin: 5em 0;
  @include mobile {
    margin: 3em 0;
  }
}

.services-container {
  margin-right: 5%;
  @include mobile {
    margin-right: 0;
  }
}

.services-container:last-child {
  margin-right: 0;
}

.technologies-container {
  margin-top: 48px;
  @include mobile {
    margin-top: 0;
  }
}

.is-borderless {
  box-shadow: none;
}

.is-full-height {
  height: 100%;
}

.logo {
  height: 60px;
  width: 60px;
  margin: 0 auto;
  @media screen and (max-width: 720px) {
    height: auto;
    width: auto;
  }
}

h2.title {
  font-weight: 600;
  letter-spacing: 5px;
  line-height: 50px;
  text-transform: uppercase;
  &.has-text-white {
    font-weight: 400;
  }
}

.content {
  h3.title.is-4 {
    letter-spacing: 2px;
  }
  h4 {
    letter-spacing: 0.8px;
  }
}
</style>
